import React, { useState, useEffect } from "react";
import { Box, Image, Text, VStack } from "@chakra-ui/react";

const Slideshow = () => {
  const images = [
    "/images/beautyImage10.webp",
    "/images/beautyImage4.webp",
    "/images/beautyImage5.webp",
    "/images/beautyImage1.webp",
    "/images/beautyImage6.webp",
    "/images/beautyImage7.webp",
  ];

  const titles = [
    "SCHOONHEIDSINSTITUUT",
    "Ontspan & Kom tot rust",
    "Gezonde huid, gelukkig jij",
    "Verjong je gloed",
    "De Ultieme Schoonheidsbeleving",
    "Transformeer je uitstraling",
    "Luxe behandelingen wachten op je",
    "Zelfzorg begint hier",
    "Verwen jezelf met schoonheid"
  ];

  const descriptions = [
    "Ervaar de beste schoonheidsbehandelingen, speciaal ontworpen voor jouw ontspanning.",
    "Ontsnap aan stress en laat onze professional voor je zorgen.",
    "Straal van binnenuit met onze premium huidverzorging.",
    "Verjong je huid met de nieuwste behandelingen op maat voor jou.",
    "Geniet van luxe schoonheidsbehandelingen die je op je best laten voelen.",
    "Ontdek een nieuwe jij met onze deskundige beauty specialiste.",
    "Stap in een wereld van ontspanning en schoonheidsverzorging.",
    "Zelfzorg is geen luxe, het is een noodzaak!",
    "Omdat je het verdient om verwend te worden."
  ];

  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      position="relative"
      left="0"
      width="100%"
      height="500px"
      overflow="hidden"
      background="black"
    >
      <Box
        display="flex"
        width={`${images.length * 100}vw`}
        transform={`translateX(-${slideIndex * 100}vw)`}
        transition="transform 0.6s ease-in-out"
      >
        {images.map((img, index) => (
          <Image
            key={index}
            src={img}
            alt={titles[index]}
            width="100vw"
            height="500px"
            objectFit="cover"
          />
        ))}
      </Box>

      <VStack
        position="absolute"
        bottom="15px"
        left="15px"
        bg="rgba(0, 0, 0, 0.6)"
        p={3}
        borderRadius="md"
        maxW={{ base: "91%", md: "40%" }}
        align="start"
      >

        <Text
        fontSize={{ base: "xl", md: "2xl" }}
        fontWeight="bold"
        color="white">
          {titles[slideIndex]}
        </Text>
        <Text fontSize="md" color="white">
          {descriptions[slideIndex]}
        </Text>
      </VStack>
    </Box>
  );
};

export default Slideshow;
